import { render, staticRenderFns } from "./PostFileItem.vue?vue&type=template&id=b74d22ee&scoped=true&"
import script from "./PostFileItem.vue?vue&type=script&lang=ts&"
export * from "./PostFileItem.vue?vue&type=script&lang=ts&"
import style0 from "./PostFileItem.vue?vue&type=style&index=0&id=b74d22ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74d22ee",
  null
  
)

export default component.exports